import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconChartHorzStacked = () => {
  return (

      <g>
        <path
          d="m.75 0 .102.007a.75.75 0 0 1 .642.641L1.5.75 1.5 2h13.55l.11.006a.95.95 0 0 1 .834.833L16 2.95v3.1l-.006.11a.95.95 0 0 1-.834.834L15.05 7h-3.052v2.55l-.006.11a.95.95 0 0 1-.834.834l-.11.006H8.996v2.55l-.006.11a.95.95 0 0 1-.833.834L8.046 14H1.5v1.25a.75.75 0 0 1-.648.743L.751 16l-.103-.007a.75.75 0 0 1-.641-.641L0 15.25V.75A.75.75 0 0 1 .648.007L.75 0zm3.249 10.5H1.751v2h2.248v-2zm3.496 0H5.496v2h2v-2zM6 7H1.751v2h4.248V7zm4.498 0H7.496v2h3.001V7zM7.999 3.5H1.751v2h6.248v-2zm6.5 0H9.496v2h5.003v-2z"
          
        />
      </g>
  );
};

export default withIcon(IconChartHorzStacked);
